<template>
    <div class="account-notifications-general">
        <div class="account-notifications-general-line">
            <label> Voulez-vous recevoir par email la lettre d'actualité sociale ? </label>
            <v-spacer />
            <v-switch
                :input-value="user.notifications ? user.notifications.actuSociale : true"
                :disabled="isSubmitting"
                :loading="loading.actuSociale"
                @change="toggleActuSociale()"
                hide-details
                inset
                class="mt-0"
            />
        </div>

        <div class="account-notifications-general-line" v-if="isSubscribedToInfoMaladie()">
            <label> Voulez-vous recevoir par email les alertes "Maladie-Prévoyance" ? </label>
            <v-spacer />
            <v-switch
                :input-value="user.notifications ? user.notifications.infoMaladie : true"
                :disabled="isSubmitting"
                :loading="loading.infoMaladie"
                @change="toggleInfoMaladie()"
                hide-details
                inset
                class="mt-0"
            />
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import userMixin from "src/mixins/user";
import { EventBus } from "src/bus/eventBus";

export default Vue.extend({
    mixins: [userMixin],
    props: ["user"],
    mounted() {
        if (!this.user.notifications) {
            const isSubscribedToInfoMaladie = this.isSubscribedToInfoMaladie();
            this.updateNotifications({
                actuSociale: true,
                infoMaladie: isSubscribedToInfoMaladie,
            });
        }
    },
    data() {
        return {
            isSubmitting: false,
            loading: {
                actuSociale: false,
                infoMaladie: false,
            },
        };
    },
    methods: {
        async toggleActuSociale() {
            this.loading.actuSociale = true;
            await this.update({
                actuSociale: this.user.notifications ? !this.user.notifications.actuSociale : true,
            });
        },
        async toggleInfoMaladie() {
            this.loading.infoMaladie = true;
            await this.update({
                infoMaladie: this.user.notifications ? !this.user.notifications.infoMaladie : true,
            });
        },
        async update(notifications) {
            try {
                this.isSubmitting = true;
                await this.updateNotifications(notifications);
                EventBus.$emit("alert:success", {
                    message: "Votre modification a bien été prise en compte",
                });
            } catch (e) {
                EventBus.$emit("alert:error", {
                    message:
                        "Une erreur technique est rencontrée. Veuillez contacter le service client Diode.",
                });
            } finally {
                this.isSubmitting = false;
                this.loading = {
                    actuSociale: false,
                    infoMaladie: false,
                };
            }
        },
    },
});
</script>

<style lang="sass" scoped>
.account-notifications-general-line
    display: flex
    padding: $grid-gutter/2
    align-items: center
</style>
